import { create } from 'zustand';
import i18n from '@/i18n/config';

type Language = 'en' | 'ar';

interface LanguageState {
  language: Language;
  setLanguage: (lang: Language) => void;
  toggleLanguage: () => void;
}

const getInitialLanguage = (): Language => {
  const storedLang = localStorage.getItem('language');
  if (storedLang === 'en' || storedLang === 'ar') {
    return storedLang;
  }
  return i18n.language.startsWith('ar') ? 'ar' : 'en';
};

export const useLanguageStore = create<LanguageState>((set, get) => ({
  language: getInitialLanguage(),
  setLanguage: (lang: Language) => {
    localStorage.setItem('language', lang);
    i18n.changeLanguage(lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === 'ar' ? 'rtl' : 'ltr';
    set({ language: lang });
  },
  toggleLanguage: () => {
    const currentLang = get().language;
    const newLang = currentLang === 'en' ? 'ar' : 'en';
    get().setLanguage(newLang);
  },
}));

// Initialize on load
useLanguageStore.getState().setLanguage(getInitialLanguage());
